/****************************************************
*****************************************************
*GESTION DU PUBLIC PATH DYNAMIC ;
***************************************************** 
****************************************************/
console.log(window.data);
__webpack_public_path__ = window.data.base + '/assets/';
/****************************************************
*****************************************************
*IMPORT GLOBALS DEPENDENCIES FROM NODE MODULES;
*****************************************************
****************************************************/